export function UserOutlined(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.3925 5.60514C8.5773 7.57434 9.03783 8.86505 9.63498 9.64134C10.1875 10.3596 10.9258 10.7317 12.0018 10.7317C13.0778 10.7317 13.8161 10.3596 14.3686 9.64134C14.9648 8.86631 15.4248 7.57853 15.6102 5.61475L15.6075 5.4971C15.524 3.84845 14.1597 2.53659 12.4896 2.53659H11.514C9.80763 2.53659 8.421 3.90557 8.3925 5.60514ZM5.85546 5.65854C5.85546 2.53341 8.38888 0 11.514 0H12.4896C15.5258 0 18.0029 2.39071 18.142 5.39316L18.1427 5.40785L18.1495 5.70107L18.143 5.77264C17.9421 7.99687 17.4019 9.85835 16.3792 11.1879C15.7978 11.9438 15.0884 12.4911 14.2751 12.8341C16.2236 13.1061 17.9452 13.7499 19.4025 14.8037C21.4073 16.2533 22.7922 18.3922 23.6166 21.1032C23.9772 22.289 23.3082 23.5424 22.1225 23.903C21.9109 23.9673 21.6909 24 21.4697 24H2.53397C2.53395 24 2.53399 24 2.53397 24C1.29465 24 0.289978 22.9954 0.289978 21.7561C0.289978 21.5349 0.32268 21.3149 0.387024 21.1033C1.21135 18.3922 2.59629 16.2533 4.60105 14.8037C6.05844 13.7499 7.78002 13.1061 9.72852 12.8341C8.91526 12.4911 8.20584 11.9438 7.62442 11.1879C6.60167 9.85835 6.06153 7.99687 5.86061 5.77264L5.85546 5.71571V5.65854ZM2.9345 21.4634H21.0691C20.3649 19.3597 19.2973 17.8579 17.9162 16.8592C16.4501 15.7991 14.5108 15.2195 12.0018 15.2195C9.49278 15.2195 7.55346 15.7991 6.08737 16.8592C4.70632 17.8579 3.63874 19.3597 2.9345 21.4634Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
